import React from 'react';
import { formatOrdinalDate } from '../utils/format';
import { getMembershipStatusLabel, getMembershipRenewalStatus } from '../utils/membership';

function MemberIdView({ clubs, currentUser, memberQrData, memberQrLoading, onApplyMembership, onRenewMembership }) {
  return (
    <div className="page-container-md">
      <div className="w3-card w3-round w3-white" style={{ marginTop: '24px' }}>
        <div className="w3-container w3-theme-d4 w3-round-top" style={{ padding: '12px 16px', textAlign: 'center' }}>
          <strong>{currentUser.name || '—'} · {memberQrData?.membershipNumber || currentUser.membershipNumber || '—'}</strong>
        </div>
        <div className="w3-container w3-padding" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center', gap: '12px' }}>
          {memberQrLoading ? (
            <p className="w3-text-grey"><i className="fa fa-spinner fa-spin w3-margin-right"></i>Loading your member ID…</p>
          ) : memberQrData ? (
            <>
              <img src={memberQrData.qrCode} alt="Member QR code" style={{ width: '220px', height: '220px', border: '1px solid #ddd', borderRadius: 8, background: '#fff' }} />
              <div style={{ width: '100%', maxWidth: '360px', textAlign: 'left', marginTop: '8px', display: 'grid', gap: '8px' }}>
                <div className="w3-border-bottom" style={{ paddingBottom: '6px' }}>
                  <div className="w3-small w3-text-grey">Club</div>
                  <div style={{ fontWeight: 600 }}>{clubs.find(c => String(c.id) === String(currentUser.ClubId))?.name || '—'}</div>
                </div>
                <div className="w3-border-bottom" style={{ paddingBottom: '6px' }}>
                  <div className="w3-small w3-text-grey">Membership type</div>
                  <div style={{ fontWeight: 600 }}>{currentUser.membershipType || '—'}</div>
                </div>
                <div className="w3-border-bottom" style={{ paddingBottom: '6px' }}>
                  <div className="w3-small w3-text-grey">Status</div>
                  <div style={{ fontWeight: 600 }}>
                    {getMembershipStatusLabel(currentUser)}
                  </div>
                </div>
                <div>
                  {(() => {
                    const status = getMembershipRenewalStatus(currentUser);
                    /* A life member has no renewal date and never will, so
                       the label says so rather than printing a dash under a
                       heading that implies one is coming. */
                    return (
                      <>
                        <div className="w3-small w3-text-grey">{status.isLife ? 'Renewal' : 'Renewal date'}</div>
                        <div style={{ fontWeight: 600 }}>
                          {status.isLife ? 'Not needed' : (status.date ? formatOrdinalDate(status.date) : '—')}
                        </div>
                      </>
                    );
                  })()}
                </div>
              </div>
            </>
          ) : (
            <p className="w3-text-grey"><em>Member ID is unavailable right now.</em></p>
          )}

          {/* Applying and renewing belong on the page that already shows your
              membership number and its renewal date — this is the page you are
              on when you are thinking about your membership at all. Renewal
              outranks applying: when one is due, that is the thing to say. */}
          {(onRenewMembership || onApplyMembership) && (
            <div className="member-id-actions">
              {onRenewMembership ? (
                <button type="button" className="w3-button w3-round member-id-primary"
                  onClick={onRenewMembership}>
                  Renew my membership
                </button>
              ) : (
                <button type="button" className="w3-button w3-round member-id-quiet"
                  onClick={onApplyMembership}>
                  Complete my membership application
                </button>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default MemberIdView;
